import '@fe-tools/build/free-variable';

import './global.less';

import 'core-js/fn/string/includes';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/fill';

import objectFitImages from 'object-fit-images';
import * as Raven from '@fe/common/lib/raven';
import * as statisticSDK from 'utils/statisticSDK';
import { initSSO } from 'components/sso/sso';
import { once } from 'utils/common';
import { IS_FIRST_VISIT, IS_REGISTER } from 'constants/localStorage';

window.RPCONFIG.isRabbitpreEnv &&
  Raven.install(
    'https://550b6167d33947e581f3dc10e306f4c8@sentry.szzbmy.com/37'
  );
// 启用ofi使图片在IE浏览器下支撑object-fit属性
objectFitImages();

// 初始化登陆信息后再初始化fibo埋点
initSSO(() => initFiboSDK());

// 初始化注册埋点
function initFiboUserRegister() {
  const addSignupCallback =
    window.COMMON_NAVBAR && window.COMMON_NAVBAR.addSignupCallback;
  addSignupCallback &&
    addSignupCallback(() => {
      statisticSDK.pushUserRegister();
    });
}

// 初始化 fibo相关 LocalStorage
function initFiboLocalStorage() {
  const isFirstVisit = localStorage.getItem(IS_FIRST_VISIT);
  const { userInfo } = window;

  if (isFirstVisit !== '0') {
    localStorage.setItem(IS_FIRST_VISIT, '0');
  }

  if (userInfo) {
    localStorage.setItem(IS_REGISTER, '1');
  }
}

// 初始化手动登录埋点
function initFiboUserLogin() {
  const addManualSigninCallback =
    window.COMMON_NAVBAR && window.COMMON_NAVBAR.addManualSigninCallback;
  addManualSigninCallback &&
    addManualSigninCallback(() => {
      statisticSDK.pushUserLogin();
      localStorage.setItem(IS_REGISTER, '1');
    });
}

// fibosdk 初始化
function initFiboSDK() {
  if (
    window.RPCONFIG &&
    window.RPCONFIG.sdk &&
    window.RPCONFIG.sdk.enable === true
  ) {
    statisticSDK.init(
      once(() => {
        initFiboLocalStorage();
        initFiboUserLogin();
        initFiboUserRegister();
        statisticSDK.pushWebInitEvent();
        statisticSDK.pushPageViewEvent();
        statisticSDK.initPushFiboNavBarClick();
        statisticSDK.initSubNavBarClick();
        statisticSDK.initFiboMsgPopupClick();
        statisticSDK.pushMobilenitEvent();
        statisticSDK.exportFibo();
      })
    );
  }
}
